class FixedButtons {
  constructor() {
    const buttonsWrapper = document.querySelector('.js-fixed-buttons');
    if(buttonsWrapper){
      this.event(buttonsWrapper);
    }
  }
  event(buttonsWrapper) {
    gsap.to(buttonsWrapper,{
      y: 0,
      scrollTrigger: {
        trigger: 'body',
        start: 'top -300',
        end: 'top -300',
        toggleActions: 'play none reverse none',
      }
    })
  }
}